export default __webpack_public_path__ + "static/media/shirtBekoBayi.232229c7.jpg";